import React, { FC } from 'react'
import { th, useTheme, x } from '@xstyled/styled-components'
import Dropdown from '@mailstep/design-system/ui/Elements/Dropdown'
import { RoundedBackground } from '@components/elements/RoundedBackground/RoundedBackground'
import { Trans } from '@lingui/react'
import { DropdownContentWrap, DropdownPositionWrap, OptionItem, IconWrap } from './styled'
import { themeModeOptions, activeIconMap } from './constants'
import { useThemeModeToggle } from './hooks/useThemeModeToggle'

export const ThemeModeToggle: FC = () => {
  const { themeMode, showDropdown, ref, toggleDropdown, handleSelect } = useThemeModeToggle()
  const ActiveIcon = activeIconMap[themeMode]
  const theme = useTheme()

  return (
    <DropdownPositionWrap ref={ref}>
      <x.div cursor="pointer" onClick={toggleDropdown}>
        <RoundedBackground>
          <ActiveIcon width={15} height={15} fill={th.color('iconStroke')({ theme })} />
        </RoundedBackground>
      </x.div>
      <Dropdown show={showDropdown} verticalShift>
        <DropdownContentWrap>
          {themeModeOptions.map(({ mode, icon: Icon, labelId, labelDefault }) => (
            <OptionItem key={mode} $active={themeMode === mode} onClick={handleSelect(mode)}>
              <IconWrap>
                <Icon width={14} height={14} />
              </IconWrap>
              <Trans id={labelId} message={labelDefault} />
            </OptionItem>
          ))}
        </DropdownContentWrap>
      </Dropdown>
    </DropdownPositionWrap>
  )
}
